import { $t } from '@/i18n';
import { defineComponent, toRefs } from '@vue/composition-api';
import './index.scss';
import { getProps } from '@components/simpleModal/openSimpleModal';
import { getDocLink } from '@/utils/links';
import { toggleCliHttps } from '@/config/cli-settings';
const chromeTips = [
    {
        type: 'console-error',
        args: {
            console: 'GET http://localhost:port/ net::ERR_CONNECTION_REFUSED',
        },
        solutions: [{
                text: $t('k_1adebcdc'),
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'GET http://localhost:port/ net::ERR_EMPTY_RESPONSE',
        },
        solutions: [{
                text: $t('k_d9fad8fc'),
                btnText: $t('k_53525e4'),
                btnAction: () => {
                    toggleCliHttps(true, { reload: true });
                },
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'GET https://localhost:port/ net::ERR_SSL_PROTOCOL_ERROR',
        },
        solutions: [{
                text: $t('k_5c5bafb7'),
                btnText: $t('k_618ccf3b'),
                btnAction: () => {
                    toggleCliHttps(false, { reload: true });
                },
            }, {
                text: $t('k_8e240863'),
                btnText: $t('k_9ac8d514'),
                btnAction: () => {
                    window.open(getDocLink().HTTPS_DEVTOOL);
                },
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'Failed to load resource:net::ERR_SSL_PROTOCOL_ERROR',
        },
        solutions: [{
                text: $t('k_13969097'),
                btnText: $t('k_d91ee4a'),
                btnAction: () => {
                    window.location.href = window.location.href.replace(/^https/, 'http');
                },
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'blocked by CORS policy: The request client is not a secure context and the resource is in more-private address space `local`',
        },
        solutions: [{
                image: 'https://vfiles.gtimg.cn/vupload/20211019/7e61b91634629215335.png',
                // i18n ignore next line
                text: '浏览器禁止请求localhost，请打开 <span class="highlight-font">chrome://flags/#block-insecure-private-network-requests </span> 设置 Block insecure private network requests 为 disabled',
            }],
    },
];
const tips = navigator.userAgent.includes('Chrome') ? chromeTips : null;
export default defineComponent({
    name: 'localLoadErrorModal',
    props: {
        ...getProps(),
    },
    setup(props) {
        const { context } = toRefs(props);
        return {
            debugType: context.value?.debugType || $t('k_d5bd0640'),
            tips,
        };
    },
    render() {
        return (<a-modal visible={true} ok-text={$t('k_c7ec97ab')} class="local-load-error-modal" cancel-text={$t('k_9e48cac4')} centered title={$t('k_7876b718', { arg_0: this.debugType })} width="800px" onOk={this.onSuccess} onCancel={this.onCancel}>
        {this.tips ? (<div class="content-box">
            {$t('k_364bed80')}
            {this.tips.map((item, index) => (<div class="content-item">
                <div>
                  <a-icon class="content-item-icon" type="exclamation-circle"/>
                  {$t('k_c5938325')}{index + 1} {$t('k_72401e86')}
                  <div class="console-error">{item.args.console}</div>
                </div>
                {item.solutions.map((solution, index) => (<div class="contenet-item-solution">
                  <a-icon class="content-item-icon" type="alert"/>
                  {$t('k_bb4c927a')}{index + 1}：<span domPropsInnerHTML={solution.text}></span>
                  {solution.btnText ? (<a-button type="link" onClick={solution.btnAction}>
                      {solution.btnText}
                    </a-button>) : null}
                  {solution.image ? <img class="pic" src={solution.image}/> : null}
                </div>))}
               </div>))}
          </div>) : ($t('k_edd438c2'))}
      </a-modal>);
    },
});
